export type SmsTemplateKey =
  | 'UNANSWERED'
  | 'CONTACT'
  | 'REVIEW'
  | 'INTAKE'
  | 'DCR'
  | 'DOL'
  | 'SEVERANCE'

export interface SmsTemplateDefinition {
  key: SmsTemplateKey
  label: string
  description: string
  requiresAttorney: boolean
  body: string
}

/** Severance review intake emails (firm standard) */
export const SEVERANCE_REVIEW_EMAIL_LINE = 'tom@cmlaw.com or paul@cmlaw.com'

export const SMS_TEMPLATE_DEFINITIONS: SmsTemplateDefinition[] = [
  {
    key: 'UNANSWERED',
    label: 'Return Call',
    description: 'Return missed call',
    requiresAttorney: true,
    body:
      'This is {attorney_name}. I am an employment attorney with Castronovo & McKinney https://www.cmlaw.com. I am returning your call. Please text me or give me a call back at {attorney_phone}. Thanks.\n\nThis is an automated message from Castronovo & McKinney, LLC. Please do not reply to this text, as responses are not monitored. Please reply to {attorney_phone}.',
  },
  {
    key: 'CONTACT',
    label: 'Follow-up Contact',
    description: 'Provide contact info',
    requiresAttorney: true,
    body:
      'Thank you for taking the time to speak with me. My email is {attorney_email}. You can also find more information on our website www.cmlaw.com. Please do not reply to this text, as responses are not monitored. Please reply to {attorney_phone}.',
  },
  {
    key: 'REVIEW',
    label: 'Review Request',
    description: 'Invite client to leave a review',
    requiresAttorney: false,
    body:
      'Thank you for taking the time to speak with us and we hope that the discussion was beneficial. If you have the time, please leave us a review by clicking on the following link - {review_url}. Future customers find the reviews very helpful. Thanks and feel free to call us back if you have any additional questions.',
  },
  {
    key: 'INTAKE',
    label: 'Intake Form',
    description: 'Send intake questions link',
    requiresAttorney: false,
    body:
      'Thank you for contacting our firm. Please complete the necessary intake questions using this link: {intake_url}\n\nIf you have trouble with the link, call our office and we will help you complete the form.',
  },
  {
    key: 'DCR',
    label: 'DCR Information',
    description: 'Division on Civil Rights contact',
    requiresAttorney: false,
    body:
      'We recommend that you contact the New Jersey Division of Civil Rights. You can reach them by calling 973-648-2700.',
  },
  {
    key: 'DOL',
    label: 'DOL Information',
    description: 'Department of Labor contact',
    requiresAttorney: false,
    body:
      'We recommend that you contact the New Jersey Department of Labor. You can find the applicable contact information at this website - https://www.nj.gov/labor/.',
  },
  {
    key: 'SEVERANCE',
    label: 'Severance Review',
    description: 'Explain $750 review and negotiation fees',
    requiresAttorney: false,
    body:
      'Thank you for contacting our firm regarding your severance review. We charge $750 for the review, meeting and to provide you with our written comments. If you would like to proceed with the severance review, please email your agreement to {severance_emails}. We will email you with available times for the review. If you would like us to negotiate the severance for you, we recommend first doing the review to make sure it is worth retaining us to negotiate it on your behalf. We charge an additional $2,250 plus 25% of any increase that we negotiated on your behalf.',
  },
]

export const SMS_TEMPLATE_MAP = Object.fromEntries(
  SMS_TEMPLATE_DEFINITIONS.map((t) => [t.key, t])
) as Record<SmsTemplateKey, SmsTemplateDefinition>
